<template>
	<el-row :gutter="20">
		<el-col :span="8"><div class="el-field-label">{{label}}</div></el-col>
		<el-col :span="16"><div class="el-field-value">
			<slot></slot>
		</div></el-col>
	</el-row>
</template>

<style>
	.el-field-label{
		text-align: right;
		font-weight: bold;
	}
	.el-field-value{

	}
</style>

<script>
    export default {
		name: 'el-field',
    	props: {
    		label: String,
    	}
    }
</script>